import styled from 'styled-components';
import { breakpoints } from '@src/common/breakpoints';
import { HiddenProps } from '.';

export const HiddenContainer = styled.div<HiddenProps>`
  display: none;

  ${({ lgDown }) => lgDown && `@media (min-width: ${breakpoints.large}) { display: block; }`}
  ${({ lgUp }) => lgUp && `@media (max-width: ${breakpoints.large}) { display: block; }`}
  ${({ mdDown }) => mdDown && `@media (min-width: ${breakpoints.mediumTablet}) { display: block; }`}
  ${({ mdUp }) => mdUp && `@media (max-width: ${breakpoints.mediumTablet}) { display: block; }`}
  ${({ smDown }) => smDown && `@media (min-width: ${breakpoints.smallTablet}) { display: block; }`}
  ${({ smUp }) => smUp && `@media (max-width: ${breakpoints.smallTablet}) { display: block; }`}
  ${({ xlDown }) => xlDown && `@media (min-width: ${breakpoints.extraLarge}) { display: block; }`}
  ${({ xlUp }) => xlUp && `@media (max-width: ${breakpoints.extraLarge}) { display: block; }`}
  ${({ xsDown }) => xsDown && `@media (min-width: ${breakpoints.mobile}) { display: block; }`}
  ${({ xsUp }) => xsUp && `@media (max-width: ${breakpoints.mobile}) { display: block; }`}
`;
